__turbopack_context__.v({
  "headerRow": "trace-module-scss-module__fp6WzW__headerRow",
  "headerRowNoData": "trace-module-scss-module__fp6WzW__headerRowNoData",
  "mobileHide": "trace-module-scss-module__fp6WzW__mobileHide",
  "partySideCellBuy": "trace-module-scss-module__fp6WzW__partySideCellBuy",
  "partySideCellSell": "trace-module-scss-module__fp6WzW__partySideCellSell",
  "searchInput": "trace-module-scss-module__fp6WzW__searchInput",
  "searchInputWrapper": "trace-module-scss-module__fp6WzW__searchInputWrapper",
  "tableFooterLabel": "trace-module-scss-module__fp6WzW__tableFooterLabel",
  "title": "trace-module-scss-module__fp6WzW__title",
  "titleContainer": "trace-module-scss-module__fp6WzW__titleContainer",
  "titleTools": "trace-module-scss-module__fp6WzW__titleTools",
  "withChart": "trace-module-scss-module__fp6WzW__withChart",
});
